// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoRecorder/style.css
// module id = 3453
// module chunks = 29